import { cn } from "common/utils/utils";

export const SocialShare = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  // const location = useLocation();
  // const currentUrl = window.location.origin + location.pathname;

  return (
    <div
      onClick={onClick}
      className={cn(
        "flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-full bg-[#F6F6F6]",
        className,
      )}
    >
      <img src="/assets/icons/share_large.svg" alt="Share" />
    </div>
  );
};
